import { Button } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useUserState from '../../../hooks/useUserState';
import { PermissionName } from '../../../types/Auth';

import BulkInactivateContinuityModal from './BulkInactivateContinuityModal';

interface BulkInactivateButtonProps {
  onAfterInactivate?: () => void;
}

const BulkInactivateButton = ({
  onAfterInactivate,
}: BulkInactivateButtonProps) => {
  const { t } = useTranslation();
  const { isAuthorizedTo } = useUserState();
  const [isOpen, setIsOpen] = useState(false);

  if (
    !isAuthorizedTo([
      PermissionName.STUDENT_MANAGEMENT_STUDENT_STATUS_BULK_INACTIVATE_CONTINUITY,
    ])
  ) {
    return null;
  }

  return (
    <>
      <Button
        style={{ minHeight: '40px' }}
        type="button"
        text={t('studentStatus.bulkInactivate.button')}
        onClick={() => setIsOpen(true)}
        size="sm"
        fullwidth
      />
      <BulkInactivateContinuityModal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        onAfterInactivate={onAfterInactivate}
      />
    </>
  );
};

export default BulkInactivateButton;
